import React from 'react';
import type { Maybe } from '@soundxyz/utils';
import { FollowButton } from '@components/basics/FollowButton';
import { Button } from '@components/main-components/button/Button';

import { NAV_LINKS } from '@utils/constants';

export const FollowEdit = ({
  owner,
  userId,
  artistId,
}: {
  owner: boolean;
  userId: string;
  artistId: Maybe<string>;
}) => {
  if (owner) {
    return (
      <Button
        variant="tertiary"
        size="L"
        href={NAV_LINKS.ProfileEdit}
        label="Edit Profile"
        className="h-9 font-title text-title-xs md:h-10 "
      />
    );
  }

  return (
    <FollowButton
      variant="tertiary"
      userId={userId}
      className="h-9 font-title text-title-xs md:h-10"
      sourceLocation="Action Bar"
      artistId={artistId}
    />
  );
};
